<script>
  import {navStatus} from "../AppState/Stores.js";
</script>

<p>Sign in to your account, or create a new account to get started!</p>
<button on:click="{ () => {
       navStatus.update(value => 'waitlist');
        }
       }"
>
  Sign-In / Create An Account
</button>

<style>
  button {
    margin-bottom: 50px;
  }
</style>